var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipseInner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 88,
    viewBox: "0 0 96 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.650459 106.44C1.91706 46.5309 51.5101 -1.00858 111.42 0.25802C171.329 1.52462 218.869 51.1177 217.602 111.027C216.335 170.937 166.742 218.476 106.833 217.21C46.9233 215.943 -0.616144 166.35 0.650459 106.44ZM172.891 110.082C173.636 74.8656 145.691 45.7136 110.474 44.969C75.258 44.2245 46.106 72.1694 45.3615 107.386C44.6169 142.602 72.5618 171.754 107.778 172.499C142.994 173.243 172.146 145.298 172.891 110.082Z",
    fill: "url(#paint0_radial_1409_580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1409_580",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.126 108.734) rotate(-88.7888) scale(108.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#0BAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2DFDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseInner);
export default __webpack_public_path__ + "static/media/ellipse_inner.56252afcc2857eb892cadbf7d9762401.svg";
export { ForwardRef as ReactComponent };